<nz-steps [(nzCurrent)]="current">
  <nz-step *ngFor="let step of steps"
           [nzTitle]="step.title">
  </nz-step>
</nz-steps>
